'use client';

import { CategoryStoryblok } from '@/types/types-storyblok';
import clsx from 'clsx';
import Link from 'next/link';
import { StoryblokStory } from 'storyblok-generate-ts';

export const CategoryFilter = ({ selectedId, categories }: { selectedId?: string; categories: StoryblokStory<CategoryStoryblok>[] }) => {
  return (
    <div className="px-4 flex flex-col md:px-20 lg:flex-row xl:mx-auto xl:max-w-screen-xl xl:px-0 mt-6 gap-4">
      <ul className={clsx('flex flex-row gap-2 flex-wrap md:flex-grow justify-center', selectedId && 'lg:ml-4')}>
        {selectedId && (
          <li>
            <Link
              href="/guide"
              scroll={false}
              className={clsx(
                !selectedId ? 'bg-elty-green text-white' : 'bg-brandGreen-50 text-neutral-darker',
                'transition-colors w-auto whitespace-nowrap rounded px-2.5 py-2 text-left flex items-center gap-4 hover:bg-brandGreen-200 hover:text-neutral-darker group text-sm',
              )}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                className={!selectedId ? 'fill-white' : 'fill-neutral-darker'}
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1684_10099)">
                  <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" />
                </g>
                <defs>
                  <clipPath id="clip0_1684_10099">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <span>Mostra tutti</span>
            </Link>
          </li>
        )}

        {categories
          .sort(a => (a.uuid === selectedId ? -1 : 1))
          .map(category => (
            <li key={category.id}>
              <Link
                scroll={false}
                href={`/guide/categorie/${category.slug}`}
                className={clsx(
                  selectedId === category.uuid ? 'bg-elty-green text-white' : 'bg-brandGreen-50 text-neutral-darker',
                  'text-sm rounded inline-block px-2.5 py-2 text-left whitespace-nowrap cursor-pointer hover:bg-brandGreen-200 hover:text-neutral-darker transition-colors',
                )}
              >
                {category.content.name}
              </Link>
            </li>
          ))}
      </ul>
    </div>
  );
};
